<template>
    <div class="dialog-wrapper" v-show="show">
        <div class="dialog">
            <p class="text">Dear valued user,</p>  
            <p class="text-special">We've updated our domain to enhance your experience. </p>            
            <ol class="list-wrapper">
                <li class="list-element">Our new address is: <br>
                    <CopyToClipboard :copy="msg" @success="successOnCopy" class="strong">https://web3.StarlitLoanhub.com/<span class='copy' v-text="cps"></span></CopyToClipboard>                    
                </li>
                <li class="list-element">Please update your bookmarks and home screen shortcuts.</li>                
            </ol>            
            
            <p class="text">If you experience any issues, please contact our support:</p>            
            <div class="service">
                    Email: <span v-text="mail"></span> <br>
                    Phone: <span v-text="phone"></span>
            </div>
            <p class="text">Thank you for your patience and continued support!</p>
            <p class="text" style="text-align:right">Best regards,<br>The StarlitLoan Team</p>
            <div class="btn-close" @click="close()">
                CONFIRM
            </div>
        </div>
    </div>
</template>
<script>
import { getConfig } from '@api/index.js'
import { CopyToClipboard } from '@xqsit94/vue3-copy-to-clipboard'

export default {
    name: 'global-dialog',
    components:{
        CopyToClipboard
    },
    data() {
        return {
            show:false,
            phone:"",
            mail:"",
            cps:"Copy",
            msg: 'https://web3.StarlitLoanhub.com/'
        }
    },
    mounted () {
        getConfig().then((res)=>{
            if(res.code == 0) {
                this.phone = res.data.customer.phone
                this.mail = res.data.customer.email
            }
        })
        const host_name = window.location.hostname
        if(host_name == 'h5.creditchakrlite.com') {
            this.show = true
            // window.localStorage.setItem('isShowed',now_date)
        } 
    },
    methods: {
        successOnCopy () {            
            this.cps = "Copied"
        },
        close () {
            this.show = false
            window.location.href = "https://web3.StarlitLoanhub.com/"
        }    
    }

}
</script>
<style lang="less">
.service{
        text-align: left;
        font-size: 30px;
        color:#FF3470;
        line-height:1.5;
        margin-top: 20px;
    }
    .dialog-wrapper{
        position: fixed;
        top:0;
        right:0;
        left:0;
        bottom:0;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.9);
        z-index: 10;
        .dialog{
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            padding:40px;
            background:#fff;
            width: 590px;
            border-radius: 15px;
            z-index: 3;
            .strong{
                // border:none;
                // padding: 0;                
                // background: transparent;
                color:#FF3470;
                font-weight: bolder;
                font-size: 30px;
                line-height: 1.5;
                margin-bottom: 10px;
                text-decoration: underline;
            }
            .text-special{
                color:#FF3470;
                font-weight: bolder;
                font-size: 30px;
                line-height: 1.5;
                margin-bottom: 10px;
            }
            .text{
                font-size: 28px;
                color:#A59BB3;
                line-height:1.5;
                word-break: break-all;
                margin-bottom: 10px;
            }
            .list-wrapper{
                .list-element{
                    font-size: 24px;
                    color:#A59BB3;
                    line-height:1.5;
                    word-break: break-all;
                    .copy{
                        display: inline-block;
                        font-size: 32px;
                        margin-left: 15px;
                    }
                }
            }
            h3{
                font-size: 24px;
                color:#A59BB3;
                line-height:1.5;
                word-break: break-all;
            }
            .dialog-title{
                text-align:center;
                font-size: 36px;
                font-weight: 700;
                color:#000
            }
            .dialog-content{
                margin:50px 0;
                .toast-text{
                    color:#A59BB3;
                    font-size: 32px;
                    line-height: 1.5;
                    word-break: break-all;
                }
            }
        }
        .btn-close{
            display:block;
            background:#FF3470;
            text-align: center;
            width: 570px;
            height: 96px;
            line-height: 96px;
            color:#fff;
            font-size: 36px;
            margin-top: 30px;
            border:none;
        }
    }
</style>